var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonCustom',{attrs:{"color":_vm.color,"size":_vm.size,"loading":_vm.loading,"icon":"download"},nativeOn:{"click":function($event){$event.preventDefault();return _vm.download.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }